import styled from 'styled-components'

export const MainContainer = styled.div`
  display: grid;
  justify-items: start;
  align-items: start;
  justify-content: start;

  & > * {
    grid-area: 1 / -1;
    opacity: 0;
    transition: opacity 0.5s;
  }

  & > *:nth-child(${props => props.index + 1}) {
    opacity: 1;
  }
`
